export const DEFAULT_CHANNEL = 'quoc-hoi'



// WEBPACK FOOTER //
// ./src/constants/LiveTV.js